/**
 * Menvora — ATF load smoothing (product.ads).
 * - Fade-in de imágenes cuando decodifican (placeholder estable debajo).
 * - Corrige saltos de scroll hacia arriba al handoff Releasit / layout thrash.
 */
(function () {
  if (window.__menvoraAdsAtfLoad) return;
  window.__menvoraAdsAtfLoad = true;

  var HOLD_MS = 520;
  var JUMP_PX = 48;
  var lockedY = null;
  var lockUntil = 0;
  var holdRaf = 0;
  var userTouching = false;

  function nowY() {
    return window.scrollY !== undefined ? window.scrollY : window.pageYOffset || 0;
  }

  function markImg(img) {
    if (!img) return;
    img.classList.add('is-decoded');
    var frame = img.closest('[data-menvora-media-frame], .menvora-media-frame');
    if (frame) frame.classList.add('is-media-ready');
  }

  function bindImg(img) {
    if (!img || img.dataset.menvoraAtfBound === '1') return;
    img.dataset.menvoraAtfBound = '1';
    if (img.complete && img.naturalWidth > 0) {
      markImg(img);
      return;
    }
    img.addEventListener(
      'load',
      function () {
        markImg(img);
      },
      { once: true }
    );
    img.addEventListener(
      'error',
      function () {
        markImg(img);
      },
      { once: true }
    );
  }

  function scan(root) {
    var scope = root && root.querySelectorAll ? root : document;
    scope.querySelectorAll('.product--ads-stack .product__media img, .product--ads .menvora-media-img').forEach(bindImg);
  }

  function holdTick() {
    holdRaf = 0;
    if (!lockedY && lockedY !== 0) return;
    if (Date.now() > lockUntil) {
      lockedY = null;
      return;
    }
    if (!userTouching) {
      var y = nowY();
      if (y < lockedY - JUMP_PX) {
        window.scrollTo(0, lockedY);
      } else if (y > lockedY + 2) {
        lockedY = y;
      }
    }
    holdRaf = window.requestAnimationFrame(holdTick);
  }

  function preserveScroll(ms) {
    if (userTouching) return;
    lockedY = nowY();
    if (lockedY < 24) return;
    lockUntil = Date.now() + (ms || HOLD_MS);
    if (!holdRaf) holdRaf = window.requestAnimationFrame(holdTick);
  }

  function onPointer() {
    userTouching = true;
    window.setTimeout(function () {
      userTouching = false;
    }, 180);
  }

  window.addEventListener('touchstart', onPointer, { passive: true });
  window.addEventListener('wheel', onPointer, { passive: true });
  window.addEventListener('menvora:cod-cta-stack-change', function () {
    preserveScroll(HOLD_MS);
  });

  if (typeof MutationObserver === 'function') {
    var mo = new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        var nodes = mutations[i].addedNodes;
        for (var j = 0; j < nodes.length; j++) {
          var n = nodes[j];
          if (n.nodeType !== 1) continue;
          if (n.matches && n.matches('img')) bindImg(n);
          else if (n.querySelectorAll) n.querySelectorAll('img').forEach(bindImg);
        }
      }
    });
    var root = document.querySelector('.product--ads') || document.documentElement;
    mo.observe(root, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      scan();
      preserveScroll(320);
    }, { once: true });
  } else {
    scan();
  }

  window.addEventListener('load', function () {
    scan();
    preserveScroll(400);
  });
})();
